import { useState, useEffect, useCallback } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function MISCommentary({ companyContext, filters }) {
  const [commentary, setCommentary] = useState(null);
  const [loading, setLoading] = useState(true);

  const companyId = companyContext?.companyId;
  const branchId = companyContext?.branchId;

  const fetchCommentary = useCallback(async () => {
    setLoading(true);
    try {
      const params = { ...filters };
      if (companyId) params.company_id = companyId;
      if (branchId) params.branch_id = branchId;
      const res = await axios.get(`${API}/mis/commentary`, { params });
      setCommentary(res.data.commentary);
    } catch {
      setCommentary(null);
    } finally {
      setLoading(false);
    }
  }, [filters, companyId, branchId]);

  useEffect(() => {
    fetchCommentary();
  }, [fetchCommentary]);

  if (loading) return <div className="flex items-center justify-center h-32"><div className="spinner"></div></div>;

  return (
    <div className="space-y-4" data-testid="mis-commentary-tab">
      {(commentary || []).map((c) => (
        <Card key={c.section} className="border border-slate-200 shadow-none">
          <CardHeader className="pb-2 bg-slate-50">
            <CardTitle className="text-sm font-semibold text-slate-700">{c.section}</CardTitle>
          </CardHeader>
          <CardContent className="p-4">
            <p className="text-sm text-slate-600 leading-relaxed">{c.text}</p>
          </CardContent>
        </Card>
      ))}
      {(!commentary || commentary.length === 0) && (
        <p className="text-sm text-slate-500 text-center py-8">No commentary data available. Upload data first.</p>
      )}
    </div>
  );
}
